interface LayoutProps {
  children: React.ReactNode
  cornerContent?: React.ReactNode
}

const AuthContainer = ({ children, cornerContent }: LayoutProps) => {
  return (
    <div className="c-flex c-h-full c-items-center c-justify-center  sm:c-z-50 sm:c-px-6 lg:c-px-8">
      <div className="c-relative c-box-border c-flex c-flex-col c-items-center c-bg-white xs:c-w-full xs:c-h-full xs:c-px-10 sm:c-mx-auto sm:c-h-[680px] sm:c-w-[580px] sm:c-items-start sm:c-rounded-xl sm:c-py-28 xs:c-py-20 sm:c-px-28 sm:c-shadow-lg">
        {cornerContent && <div className="c-absolute c-top-4 c-right-4">{cornerContent}</div>}
        <div className="c-w-[340px]">{children}</div>
      </div>
    </div>
  )
}

export default AuthContainer
